import { t } from "@travily/i18n";
import { Icon } from "@ui/components/Icon";
import { StandardButton } from "@ui/components/StandardButton";
import { Link } from "@ui/primitives/Link";

export interface InvalidViewProps {
  /** Destination for the "back home" button. */
  homeHref: string;
}

// Shown for a tampered/unknown download token — no buyer details, just a dead end.
export const InvalidView = ({ homeHref }: InvalidViewProps) => (
  <div className="mx-auto w-full max-w-2xl py-16 text-center">
    <div className="mb-6 flex justify-center text-neutral-400">
      <Icon name="invalid" size="32" />
    </div>
    <h1 className="font-bold text-2xl text-neutral-900">{t("web.purchases.downloads.invalid.heading")}</h1>
    <p className="mt-3 text-base text-neutral-600">{t("web.purchases.downloads.invalid.description")}</p>

    <div className="mt-8 flex justify-center">
      <Link href={homeHref}>
        <StandardButton color="pink" size="44">
          {t("web.purchases.downloads.invalid.back_home")}
        </StandardButton>
      </Link>
    </div>
  </div>
);
